import { motion } from "framer-motion";

const STATS = [
  { value: "35+", label: "Years of experience & trust" },
  { value: "500+", label: "Families guided across India" },
  { value: "₹100 Cr+", label: "Assets advised & protected" },
  { value: "24 hrs", label: "Call-back promise, every time" },
];

export const Stats = () => (
  <section id="why-us" className="border-y border-border bg-white">
    <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          data-testid={`stat-card-${i}`}
          className="px-6 py-10 lg:px-10 lg:py-14 border-border [&:nth-child(odd)]:border-r lg:[&:not(:last-child)]:border-r"
        >
          <p className="font-serif text-4xl lg:text-5xl font-medium text-forest">{s.value}</p>
          <p className="mt-2 text-sm text-muted-foreground">{s.label}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
